export default {
    ee: {'country': ['ee']},
    eeru: {'country': ['ee']},
    pl: {'country': ['pl']},
    lt: {'country': ['lt']},
    lv: {'country': ['lv']},
    lvru: {'country': ['lv']},
    ua: {'country': ['ua']}
}
